import { render, staticRenderFns } from "./ContractProfile.vue?vue&type=template&id=bed43dd4&scoped=true"
import script from "./ContractProfile.vue?vue&type=script&lang=js"
export * from "./ContractProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed43dd4",
  null
  
)

export default component.exports